import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Box = styled.div`
  display: flex;
  list-style: none;
`;

const Flex = ({ children, ...props }) => (
  <Box {...props}>
    {children}
  </Box>
  );

Flex.propTypes = {
  children: PropTypes.any,
};

export default Flex;



// WEBPACK FOOTER //
// ./src/components/Atoms/Flex/index.js